import { render, staticRenderFns } from "./CreatedOrEditedInsurance.vue?vue&type=template&id=b8ba56d0&scoped=true&"
import script from "./CreatedOrEditedInsurance.vue?vue&type=script&lang=js&"
export * from "./CreatedOrEditedInsurance.vue?vue&type=script&lang=js&"
import style0 from "./CreatedOrEditedInsurance.vue?vue&type=style&index=0&id=b8ba56d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ba56d0",
  null
  
)

export default component.exports